import { DecorationModel } from "../_model/DecorationModel";
import { ControllerArrow } from "./controllerArrow"
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import * as d3 from "d3"
import EventMouse from "../_decorationTools/eventMouse";

export class DecorationArrow extends DecorationModel {
  constructor() {
    super("DecorationArrow")
    this.node = null;
    this.ctr = new ControllerArrow();
  
    this.init = async function (newNode, openDialog) {
      let svg = SingletonFlowchart.svg
      this.node = newNode
  
       await svg
          .data([newNode])
          .append("g")
          .attr("id", `${newNode.idName}`)
          .classed("Arrow", true)
          .attr("x",  d => d.x)
          .attr("y", d => d.y)
          .style("cursor", "grab")
          .on("dblclick", () => openDialog(newNode))
          .call(this.setDrag())

        let g = d3.select(`#${newNode.idName}`)

        g.append("path")
          .classed("Line", true)
          .attr("d", newNode.pathLine())
          .attr("stroke", newNode.color)
          .attr("stroke-width", newNode.stroke)
          .style("cursor", "pointer")

        g.append("circle")
          .classed(`circle-hide`, true)
          .attr('cx', d => d.x)
          .attr('cy', d => d.y)
          .style("cursor", "pointer")
          .attr('r', newNode.stroke)
          .attr('fill', "#0000")
          .on('mouseover', () => EventMouse.mouseOver(newNode))
          .on('mouseout', () => EventMouse.mouseOut(newNode))
          .on('dblclick', () => openDialog(newNode))
          .call(this.setDragCircle())

        let d3Triangle = d3.symbol().type(d3.symbolTriangle).size(newNode.size);  
        g.append("path")
          .classed("Triangle", true)
          .style("cursor", "pointer")
          .attr("d", d3Triangle)
          .attr("transform", d => `translate(${d.xArrow()}, ${d.yArrow()})rotate(${d.rotate})`)
          .style("fill", d => d.color)
          .on("dblclick", () => openDialog(newNode))

      return svg
    }
  
    this.setDrag = function() {
      if(this.node.readOnly)
        return d3.drag();

      let that = this
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d))
        .on("end", (event, d) => that.dragended(event, d));
      return drag;
    }

    this.dragstarted = function(event, d) {
      SingletonFlowchart.selectNode(`${d.idName}`)
      d.setLineXY1()
    }

    this.dragged = async function (event, d){
      d.x = event.x;
      d.y = event.y;

      await this.move()
    } 

    this.move = async function () {
      let d = this.node

      await d3.select(`#${d.idName} > path.Line`).attr("d", await d.pathLine()).node();
      await d3.select(`#${d.idName} > path.Triangle`).raise().attr("transform", d => `translate(${d.xArrow()}, ${d.yArrow()})rotate(${d.rotate})`)      
      await d3.select(`#${d.idName} > circle`).raise().attr("cy", d => d.y).attr("cx", d => d.x)
    }

    this.dragended = function(event, d) {
      d.setLineXY1()
    };

    this.update = function(){
      let d = this.node;
      let triangle = d3.symbol().type(d3.symbolTriangle).size(d.size);

      d3.select(`#${d.idName} > path.Triangle`)
        .style("stroke", 'none')
        .style("cursor", "pointer")
        .attr("d", triangle)
        .attr("transform", `translate(${d.xArrow()}, ${d.yArrow()})rotate(${d.rotate})`)
        .style("fill", d.color)

      d3.select(`#${d.idName} > path.Line`)
        .style('stroke', d.color)
        .attr("d", d.pathLine())
        .attr("stroke-width", d.stroke)

      d3.select(`#${d.idName} > circle`).raise().attr("cy", d => d.y).attr("cx", d => d.x)


      SingletonFlowchart.SaveStatus()
    }


    this.setDragCircle = function() {
      if(this.node.readOnly)
        return d3.drag();

      let that = this
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.draggedCircle(event, d))
        .on("end", (event, d) => that.dragendedCricle(event, d));
      return drag;
    }

    this.draggedCircle = async function (event, d){
      if(!d.arrowChanged){
        await d.setDifInDrag(event)
      }

      await d3.select(`#${d.idName} > path.Line`).attr("d", await d.pathLineByResize()).node();
      await d3.select(`#${d.idName} > circle`).raise().attr("cy", d => d.y).attr("cx", d => d.x)
    }

    this.dragendedCricle= function(event, d){
      d.setDif()
      d.arrowChanged = false
    }
  }
}